import { render, staticRenderFns } from "./PazienteInfoComponent.vue?vue&type=template&id=018b6440"
import script from "./PazienteInfoComponent.vue?vue&type=script&lang=js"
export * from "./PazienteInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports